export default __webpack_public_path__ + "31213cfdeed096cdff053cec506b73cb.png";